<template>
    <v-container>
        <v-container class="bg-red">
            <v-row justify="center"><h2>Sale</h2></v-row>
        </v-container>
        <v-data-table
            :headers="outputheaders"
            :items="billcomputed"
            items-per-page="-1"
        ></v-data-table>

        <v-container class="bg-red">
            <v-row justify="center"><h2>Credit Notes</h2></v-row>
        </v-container>
        <v-data-table
            :headers="outputheaders"
            :items="cncomputed"
            items-per-page="-1"
        ></v-data-table>
    </v-container>
</template>
<script setup>
import { ref, provide, computed, onMounted,onBeforeMount,watch, onUpdated, onBeforeUpdate } from 'vue'
import moment from 'moment';

const props = defineProps(['gmwswitch','company','date', 'billdata','cndata'])

var billdata = ref(props.billdata)
var cndata = ref(props.cndata)

var outputheaders = ref([
    {
        title: 'GST No',
        align: 'start',
        sortable: true,
        key: 'gstno',
    },
    { title: 'Party', key: 'party' },
    { title: 'Invoice No', key: 'billno' },
    { title: 'Invoice Date', key: 'billdate' },
    { title: 'Invoice Value', key: 'billamount' },
    { title: 'Place of Supply', key: 'placeofsupply' },
    { title: 'Reverse Charge', key: 'revchg' },
    { title: 'Taxrate', key: 'taxrate' },
    { title: 'Invoice Type', key: 'inv_type' },
    { title: 'Ecom', key: 'ecom' },
    { title: 'Gstrate', key: 'gstrate' },
    { title: 'Taxable Value', key: 'taxable' },
  
])

const billcomputed = computed(() => {

    var billarray1 = []
    for(let i = 0; i < billdata.value.length; i++){
        var bill = billdata.value[i]
        var sales = billdata.value[i].productsales
        for(let j = 0; j < sales.length; j++){
            var sale = sales[j]
            var gstno = bill.party.gstno
            var party = bill.bills_partyname
            var billno = bill.billno
            var gstrate = (sales[j].igst_rate != 0) ? Number(sales[j].igst_rate) : (Number(sales[j].cgst_rate) + Number(sales[j].sgst_rate))

            const found = billarray1.some(el => el.gstno === gstno && el.billno === billno && el.gstrate === gstrate)

            if(!found){
                billarray1.push({
                    gstno: gstno,
                    party: party,
                    billno: billno,
                    billdate: moment(bill.billdate).format('DD-MMM-YY'),
                    billamount: bill.billamount,
                    placeofsupply: bill.party.state.state_code+'-'+bill.party.state.state_name,
                    revchg: 'N',
                    taxrate:'',
                    inv_type:'Regular_B2B',
                    ecom: '',
                    gstrate: gstrate,
                    taxable: Number(sale.taxable)
                })
            }else{
                var index = billarray1.findIndex(x => x.gstno === gstno && x.billno === billno && x.gstrate === gstrate)
                billarray1[index].taxable += Number(sale.taxable)
            }
            
        }
    }

    var billtopass = billarray1.map(v => ({ ...v,
        taxable: (Math.round(v.taxable * 100) / 100).toFixed(2)
    }))

return billtopass
})

const cncomputed = computed(() => {

var billarray1 = []
for(let i = 0; i < cndata.value.length; i++){
    var bill = cndata.value[i]
    var sales = cndata.value[i].productsales
    for(let j = 0; j < sales.length; j++){
        var sale = sales[j]
        var gstno = bill.party.gstno
        var party = bill.bills_partyname
        var billno = bill.billno
        var gstrate = (sales[j].igst_rate != 0) ? Number(sales[j].igst_rate) : (Number(sales[j].cgst_rate) + Number(sales[j].sgst_rate))

        const found = billarray1.some(el => el.gstno === gstno && el.billno === billno && el.gstrate === gstrate)

        if(!found){
            billarray1.push({
                gstno: gstno,
                party: party,
                billno: billno,
                billdate: moment(bill.billdate).format('DD-MMM-YY'),
                billamount: bill.billamount,
                placeofsupply: bill.party.state.state_code+'-'+bill.party.state.state_name,
                revchg: 'N',
                taxrate:'',
                inv_type:'Regular_B2B',
                ecom: '',
                gstrate: gstrate,
                taxable: Number(sale.taxable)
            })
        }else{
            var index = billarray1.findIndex(x => x.gstno === gstno && x.billno === billno && x.gstrate === gstrate)
            billarray1[index].taxable += Number(sale.taxable)
        }
        
    }
}

var billtopass = billarray1.map(v => ({ ...v,
    taxable: (Math.round(v.taxable * 100) / 100).toFixed(2)
}))

return billtopass
})

onBeforeMount(async () => {

})

onBeforeUpdate(async () => {
    billdata.value = props.billdata
    cndata.value = props.cndata
})
</script>